const colors = ['#d97706', '#84cc16', '#06b6d4', '#8b5cf6', '#ec4899']

const getColor = () => {
	const index = Math.floor(Math.random() * colors.length)
	return colors[index]
}

export default getColor
